export default "__VITE_ASSET__Cl1dgtgY__"